import axios from "axios";

const RetryCount = 2;
const RetryWaitMs = 100;

const api = axios.create({
	baseURL: process.env.VUE_APP_BASE_URL,
	timeout: 100000000,
	retry: RetryCount,
	retryDelay: RetryWaitMs
});

api.interceptors.request.use((config) => callInterceptor(config));
api.interceptors.response.use(
	(response) => response,
	(error) => errorInterceptor(error));


function callInterceptor(config) {
	const sessionInfo = localStorage.getObject('sessionInfo');
	if (!sessionInfo) return config;
	if (!sessionInfo.KeyCloakParam) return config;
	if (!sessionInfo.KeyCloakParam.KeyCloakToken) return config;
	config.headers = {
		'x-functions-key': sessionInfo.FuncAppKey,
		common: {        // can be common or any other method
			accessToken: sessionInfo.KeyCloakParam.KeyCloakToken.access_token,
		}
	}

  checkSessionStatus(sessionInfo, config);

	return config;
}

function checkSessionStatus(sessionInfo, config){
  const jwt = sessionInfo.KeyCloakParam.KeyCloakToken.access_token.split('.')[1];
  const decodedJwt = JSON.parse(atob(jwt));

  if (decodedJwt.exp * 1000 < Date.now()) {
    localStorage.setObject("sessionInfo", null);

    errorInterceptor({
      response: {
        status: 401,
        data: "Session expired"
      },
      config: config
    });
  }
}

function errorInterceptor(error) {
	console.log('axios.interceptors error: ' + error + (error.status != undefined ? '\nStatus: ' + error.status.data : ''));
	if (error.message && error.message == "Network Error") {
		showError("Die Server-Schnittstelle ist nicht verfügbar. Bitte versuchen Sie es später erneut.");
		return;
	}
	const { config } = error;
	if (!config || !config.retry) {
		if (error.response && error.response.status && error.response.status == 403) {
			this.$router.go(0);
			return Promise.reject(error);
		}
		return this.$confirm({
			title: "Unbekannter Fehler",
			text: "Es ist ein unbekannter Fehler aufgetreten. Bitte melden Sie sich beim Support.\n" + error,
			dialogMaxWidth: 400,
			acceptText: "Neu laden",
			cancelText: "Schliessen"
		}).then(ifaccept => {
			if (ifaccept) this.$router.go(0);
		}).catch(error => {
			console.log(error);
		});
	}
	if (error.response && error.response.status) {
		console.log('returned status: ' + error.response.status);
		if (error.response.status == 401 || error.response.status == 403) {
			return refreshSessionOrLogin().then(() => {
				config.retry--;
				console.log("token refreshed by retry: " + (RetryCount - config.retry) + "/" + RetryCount);

				const apiInstance = config.baseURL.includes(process.env.VUE_APP_ARTIKEL_APP_URL)
					? this.artikelAppApi
					: this.api;
				return retryRequest(config, RetryCount - config.retry, config.retryDelay || RetryWaitMs, apiInstance);
			});
		} else if (error.response.status == 404) {
			return this.$confirm({
				title: "Server nicht erreichbar",
				text: "Der Server '" + process.env.VUE_APP_BASE_URL + "' konnte nicht erreicht werden. Bitte laden sie die Seite neu.\n" + error,
				dialogMaxWidth: 400,
				acceptText: "Neu laden",
				cancelText: "Schliessen"
			}).then(ifaccept => {
				if (ifaccept) this.$router.go(0);
			}).catch(error => {
				console.log(error);
			});
		} else {
			showError(error);
		}
	}
	return Promise.reject(error);
}

function retryRequest(config, retryCount, retryDelay, apiInstance) {
	return new Promise((resolve) => {
		setTimeout(() => {
			console.log(`Retrying request: ${config.url}, Attempt: ${retryCount}`);
			resolve(apiInstance(config));
		}, retryDelay);
	});
}


function showError(error) {
	console.log("showError");
	console.log(error.response);
	this.$alert({
		title: "Es ist ein Fehler aufgetreten",
		text: error,
		dialogMaxWidth: 400,
		acceptText: "Schliessen"
	});
}

async function refreshSessionOrLogin() {
	const me = this;
	const sessionInfo = localStorage.getObject("sessionInfo");
	let refreshToken = null;
	let res = null;
	if (sessionInfo) {
		refreshToken = sessionInfo.KeyCloakParam.KeyCloakToken.refresh_token;
	}
	try {
		res = await me.api.get(`PBiAppAuthFlow?refresh=${refreshToken}`, {
			retry: null // Null because it will then call itself!
		});
	}
	catch (err) {
		localStorage.setObject("sessionInfo", null);
		window.location.href = process.env.VUE_APP_LOGOUT_URL;
	}
	if (res && res.status === 200) {
		localStorage.setObject("sessionInfo", res.data);
		localStorage.removeItem("echtId");
	}
	else {
		localStorage.setObject("sessionInfo", null);
		window.location.href = process.env.VUE_APP_LOGOUT_URL;
	}
}

export default api;
